import { render, staticRenderFns } from "./detectionreport.vue?vue&type=template&id=7ac723a6&"
import script from "./detectionreport.vue?vue&type=script&lang=js&"
export * from "./detectionreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports